export default __webpack_public_path__ + "static/media/stephanie_tommy-206_tn.c3c4f17f.jpg";